import { Button, FormFields, Heading, Radio, mediumMediaBreakpoint, spacingL } from "@RooUI";
import React from "react";
import styled from "styled-components";

import { SubHeaderContainer } from "@Roo/Common/EditProfile/styles";
import { useRooTranslation } from "@Roo/Common/Wrappers/useRooTranslation";
import { REASON_FOR_REGISTERING_OPTIONS } from "@Roo/constants/checkBoxConstants";

import { useFormContext } from "./RegistrationWhyAreYouOnRooFormContext";
import { ImprovedFiltersGroupWrapper } from "./styles";

export const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-end;
  height: 100%;
  margin-top: 32px;
  @media (max-width: ${mediumMediaBreakpoint}) {
    align-self: unset;
    width: 100%;
    margin-top: ${spacingL};
  }
`;

export const RegistrationWhyAreYouOnRooForm = () => {
  const { onChange, onSave, loading, errors, form } = useFormContext();

  const { t } = useRooTranslation();

  return (
    <>
      <SubHeaderContainer>
        <Heading level={2}>{t("registration.whyAreYouOnRoo.title")}</Heading>
      </SubHeaderContainer>
      <FormFields>
        <ImprovedFiltersGroupWrapper data-testid="reasonForRegistering">
          {REASON_FOR_REGISTERING_OPTIONS.map((option) => (
            <Radio
              key={option.value}
              type="informational"
              name="reasonForRegistering"
              icon={option.icon}
              label={option.label}
              value={option.value}
              subText={option.subText}
              checked={form?.reasonForRegistering === option.value}
              onChange={(e) => {
                if (onChange) {
                  onChange("reasonForRegistering", e.target.value);
                }
              }}
              error={errors?.["reasonForRegistering"]}
            />
          ))}
        </ImprovedFiltersGroupWrapper>
      </FormFields>
      <ButtonContainer>
        <Button
          $buttonType="primary"
          title="Next, Personalization"
          onClick={onSave}
          loading={loading}
          data-testid="whyAreYouOnRooContinue"
        />
      </ButtonContainer>
    </>
  );
};
